import { ReactNode } from 'react';
import styled, { StyledComponent } from '@emotion/styled';
import { IArrowButtonProps } from '../Button/ArrowButton';
import { StyledIconButton, IIconButtonProps } from '../Button/IconButton';
import { ITheme, themed } from '../../themer';
import { Link } from './Link';
import { ArrowForwardIcon } from '../Icon';
import { ButtonText } from '../Button/ButtonText';

export interface IArrowLinkButtonProps extends IArrowButtonProps {
	href: string;
	rel?: string;
	target?: string;
	secondary?: boolean;
	hideExternalIndicator?: boolean;
	icon?: ReactNode;
}

interface IStyledIconLinkButton
	extends StyledComponent<IArrowLinkButtonProps, IIconButtonProps, ITheme> {}

export const StyledIconLinkButton = StyledIconButton.withComponent(
	Link,
) as IStyledIconLinkButton;

export const StyledArrowLinkButton = styled(StyledIconLinkButton)<{}, ITheme>`
	:hover {
		text-decoration: none;
	}
	&:focus-visible {
		border-radius: 2px;
		box-shadow: 0 0 0 6px ${themed(({ typography }) => typography.body.color)};
		text-decoration: underline;
	}
`;

export function ArrowLinkButton({
	children,
	icon,
	...props
}: IArrowLinkButtonProps) {
	return (
		<StyledArrowLinkButton {...props}>
			<ButtonText>{children}</ButtonText>

			{icon ?? <ArrowForwardIcon aria-hidden="true" />}
		</StyledArrowLinkButton>
	);
}
